import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { OverviewRedux } from '../Redux/OverviewRedux'

const overviewCrudObservable = createCRUDObservable({
  mainRedux: OverviewRedux,
  reduxPath: 'overview',
})

export const overviewObservers = Object.assign({}, overviewCrudObservable.observers, {})

export const overviewEpic = combineEpics(
  overviewCrudObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/OverviewObservable.js